module.exports = __webpack_public_path__ + "img/download-white.606cfcaa.svg";